import {
  DataTable,
  DataTableProps,
  defaultColumnFilters,
  defaultSidebar
} from "@appretio/ui-kit";
import { AgGridReact } from "ag-grid-react";
import React from "react";
import { TABLE_IMAGE_HEIGHT } from "./cellRendererComponents/DataTableImageWithDialog";
import { createColumnDefinitions } from "./columnDefinitions";

export const ReviewDataTable = React.memo(
  React.forwardRef<
    AgGridReact,
    Omit<DataTableProps, "columnDefs" | "rowSelection" | "autoSizeStrategy">
  >((props, ref) => {
    return (
      <DataTable
        ref={ref}
        columnDefs={createColumnDefinitions()}
        rowSelection={{
          mode: "multiRow",
          checkboxes: true,
          headerCheckbox: true
        }}
        sideBar={{
          defaultToolPanel: defaultSidebar.sideBar.defaultToolPanel,
          position: defaultSidebar.sideBar.position as "right" | "left",
          toolPanels: defaultSidebar.sideBar.toolPanels
        }}
        statusBar={defaultSidebar.statusBar}
        alwaysMultiSort
        defaultColDef={defaultColumnFilters}
        rowHeight={TABLE_IMAGE_HEIGHT} // Set row height to match image to avoid jumping until images load
        suppressServerSideFullWidthLoadingRow={true} // Enables build-in skeleton row Loading
        {...props}
      />
    );
  })
);
